import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'mdbreact';
import {Link, withRouter} from "react-router-dom";
import {IMAGE_URL} from "./../../config/Config";
import {logoutUser} from "../../redux/actions/user";

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            isLogout:false
        };

    }
   /* handleLogOut =  ()=>{
        this.props.logoutUser(() => {
                this.setState({isLogout: true});
            });
        this.props.history.push('/login');
    };*/


    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }


    render() {
        const {user} = this.props;
        const AuthButton = withRouter(
            ({ history }) =>
               <DropdownItem href=""  onClick={() => {
                   this.props.logoutUser(() => {
                       history.push("/login");
                   });
               }}><i className=" flaticon-logout"/>  خروج</DropdownItem>
        );

        return (
            <Dropdown isOpen = { this.state.dropdownOpen } toggle = { this.toggle }>
                <DropdownToggle color="link" style={{padding: 4 }} className="user-header">
                    <img src={IMAGE_URL + user.pic} className="img-fluid rounded-circle z-depth-0" alt={user.firstName+" "+user.lastName} style={{width:25,height:25,margin:'0 5px'}}/>
                    {/*<i className="flaticon-user " style={{fontSize:18,margin:'0 5px' }}/>*/}
                    <span className="d-lg-none1">{user.firstName+" "+user.lastName}</span>

                </DropdownToggle>
                <DropdownMenu className="user-dropdown">
                    <DropdownItem header><img src={IMAGE_URL + user.pic} className="img-fluid rounded-circle z-depth-0" alt={user.firstName+" "+user.lastName}/> {user.firstName+" "+user.lastName}</DropdownItem>
                    <Link to="/profile" className="dropdown-item" ><i className=" flaticon-user "/> پروفایل من </Link>
                    <Link to="/new-job" className="dropdown-item" ><i className="la la-plus"/>   ایجاد کسب و کار </Link>
                    <Link to="/my-jobs" className="dropdown-item" ><i className="la la-building"/> کسب و کارهای من </Link>
                    {/*<Link to="/refer-to-friend" className="dropdown-item" ><i className="flaticon-users "/> پیشنهاد به دوستان</Link>*/}
                    <DropdownItem divider/>
                    <AuthButton />
                </DropdownMenu>
            </Dropdown>
        );
    }

}
const mapStateToProps = (state) => {
    return {
        user : state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        logoutUser : (cb) => {
            dispatch(logoutUser(), setTimeout(cb,0))
        }
    }
};
// export default withRouter(UserProfile);
export default connect(mapStateToProps,mapDispatchToProps)(UserProfile);




// WEBPACK FOOTER //
// ./src/components/header/UserProfile.js